module.exports = __webpack_public_path__ + "static/media/bix.3db8464b.png";